import { Route, Routes } from 'react-router-dom'
import { TableSections } from './Table/table'
import { AddSections } from './add'
import { ViewSections } from './view'

export const BrowserSections = () => {
    return (
        <Routes>
            <Route path={"/"} element={<TableSections />} />
            <Route path={"/add"} element={<AddSections />} />
            <Route path={"/view"} element={<ViewSections />} />
        </Routes>
    )
}
